<div class="info">
    <span class="label">{{label}}</span>
    <span *ngIf="date">{{date  |  date:'dd.MM.yy'}}</span>
</div>


<div class="projects-progress-bar">
    <div class="items-container">
        <span class="p-bar-item" *ngFor="let item of progressBarSteps; let i = index"
              [ngStyle]=" (i < progress) &&  {backgroundColor: activeBarItemColor}"></span>
    </div>
</div>
